import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

// @ts-ignore
/**
 * Hook to fetch detailed information for a specific inventory item within an organization.
 * @param {object} root0 - The parameters object.
 * @param {string} [root0.orgId] - The organization ID containing the item.
 * @param {string} [root0.itemId] - The inventory item ID to look up.
 * @returns {object} Org item detail query result with data, loading, success, and error states.
 */
export const useOrgItemDetail = ({ orgId, itemId } = {}) => {
  const { api, apiReady } = useAPI();
  const numOrgId = Number(orgId);
  const numItemId = Number(itemId);
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_ORG_ITEM_DETAIL, numOrgId, numItemId],
    queryFn: () => api.invMgmt.getInvItemDetails({ orgId: numOrgId, itemId: numItemId }),
    enabled: apiReady && Boolean(orgId) && Boolean(itemId) && Number.isFinite(numOrgId) && Number.isFinite(numItemId),
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    orgItemDetail: data,
    orgItemDetailIsLoading: isLoading,
    orgItemDetailIsSuccess: isSuccess,
    orgItemDetailIsError: isError,
    orgItemDetailError: error,
  };
};
